// main.js
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import router from './router'

// 生产环境使用相对路径，通过Nginx代理
if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = '/api'  // 相对路径，会走HTTPS
} else {
  axios.defaults.baseURL = 'http://m9.pulidc.com:62060'  // 开发环境
}

Vue.prototype.$axios = axios
Vue.config.productionTip = false

Vue.use(ElementUI)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')